<template>
  <div class="checkbox-item" >
    <input type="checkbox" :id="item.sh" :checked="item.is_checked == true" @change="$emit('changeditem', $event.target.checked, item)"
    v-on:click="$emit('wasClicked', item)">
    <label :for="item.sh">{{item.sh}}</label>
  </div>
</template>

<script>
export default {
  name: "CheckboxItem",
  props: [
    "item"
  ],
  data:function(){ 
    return {

    }
  },
  computed: {

  },
  methods: {
 
  }
}
</script>

